<template>
  <div id="app">
    <router-view />
    <alarm-notification ref="alarmNotification" />
  </div>
</template>

<script>
import AlarmNotification from './components/AlarmNotification/index.vue'
import webSocketService from './utils/websocketService'

export default {
  name: 'App',
  components: {
    AlarmNotification
  },
  mounted() {
    // 注册WebSocket消息处理器
    webSocketService.registerMessageHandler(this.handleWebSocketMessage)
  },
  beforeDestroy() {
    // 移除WebSocket消息处理器
    webSocketService.removeMessageHandler(this.handleWebSocketMessage)
  },
  methods: {
    // 处理WebSocket消息
    handleWebSocketMessage(message) {
      // 检查是否是报警消息
      if (message.id) {
        const abnormalAlarmDO = message.abnormalAlarmDO || {};
        const alarmData = {
          id: message.id,
          name: message.name || abnormalAlarmDO.nodeName || abnormalAlarmDO.equipName || '未知设备',
          alertName: abnormalAlarmDO.alertName || '设备报警',
          area: message.area || abnormalAlarmDO.area || '-',
          content: abnormalAlarmDO.content || '无描述',
          createTime: message.createTime ? new Date(message.createTime).toLocaleString() : new Date().toLocaleString(),
          alarmSource: message.alarmSource || '',
          duration: 0,
          nodeId: abnormalAlarmDO.nodeId,
          type: abnormalAlarmDO.type,
          equipName: abnormalAlarmDO.equipName,
          equipRoomId: abnormalAlarmDO.equipRoomId,
          alarmLevel: abnormalAlarmDO.alarmLevel,
          rawData: message
        }

        // 添加报警通知
        this.$refs.alarmNotification.addAlarm(alarmData)
      }
    },
    // 获取报警级别
    getAlarmLevel(level) {
      switch (level) {
        case '1':
        case 'high':
          return 'high'
        case '2':
        case 'medium':
          return 'medium'
        case '3':
        case 'low':
          return 'low'
        default:
          return 'medium'
      }
    }
  }
}
</script>

